export function numberWithCommas(x: number): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function hashString(str: string): number {
  let hashedValue = 30744573451;
  for (let i = 0; i < str.length; i++) {
    let val = +str.charCodeAt(i);
    hashedValue += val;
    hashedValue *= 30744573451;
    hashedValue %= 274877906944;
  }
  return hashedValue;
}

export function getDeviceType() {
  let height = window.outerHeight;
  let width = window.outerWidth;

  let returnStr = '.';
  if (width === 320 && height === 480) {
    returnStr = 'iPhone 4';
  }
  else if (width === 320 && height === 533) {
    returnStr = 'Nokia Lumina';
  }
  else if (width === 320 && height === 568) {
    returnStr = 'iPhone 5/SE';
  }
  else if (width === 360 && height === 640) {
    returnStr = 'Moto G4/Galaxy S5/Galaxy Note 3/Nexus 5';
  }
  else if (width === 375 && height === 667) {
    returnStr = 'iPhone 6/7/8';
  }
  else if (width === 375 && height === 812) {
    returnStr = 'iPhone X';
  }
  else if (width === 384 && height === 640) {
    returnStr = 'Nexus 4';
  }
  else if (width === 411 && height === 731) {
    returnStr = 'Pixel 2';
  }
  else if (width === 411 && height === 823) {
    returnStr = 'Pixel 2 XL';
  }
  else if (width === 412 && height === 732) {
    returnStr = 'Nexus 5X/Nexus 6/Nexus 6P';
  }
  else if (width === 414 && height === 736) {
    returnStr = 'iPhone 6/7/8+';
  }
  else if (width === 480 && height === 854) {
    returnStr = 'Nokia N9';
  }
  else if (width === 600 && height === 960) {
    returnStr = 'Nexus 7';
  }
  else if (width === 768 && height === 1024) {
    returnStr = 'iPad/iPad Mini';
  }
  else if (width === 800 && height === 1280) {
    returnStr = 'Nexus 10/Kindle Fire';
  }
  else if (width === 1024 && height === 1366) {
    returnStr = 'iPad Pro';
  }
  else if (width === 1112 && height === 834) {
    returnStr = '10.5-inch iPad Pro';
  }

  return `${returnStr} (${width}x${height})`;
}

export function fitInRange(value: number, min: number, max: number, defaultVal: number): number {
  if (isNaN(value)) {
    return defaultVal;
  }

  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }

  return value;
}

export function getTimeString(time: number): string {
  let minutes = Math.floor(time / 60000);
  let seconds = Math.floor((time % 60000) / 1000);
  let tenth = Math.floor((time % 1000) / 100);
  let padding = seconds < 10 ? '0' : '';
  // return `${minutes} : ${padding}${seconds}.${tenth}`;
  return `${minutes} : ${padding}${seconds}`;
}

/**
 * Generates a random integer number between min and max
 * @param min 
 * @param max 
 * @returns random integer number
 */
export function randomNum(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
